var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useAppSelector } from '../../../store';
import { participantsSelector } from '../../../store/slices/participantSlice';
const AudioElm = ({ track, userId }) => {
    _react_refresh_temp_3();
    const ref = useRef(null);
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    useEffect(() => {
        var _a;
        const el = ref.current;
        if (el) {
            (_a = track.audioTrack) === null || _a === void 0 ? void 0 : _a.attach(el);
        }
        return () => {
            var _a;
            if (el) {
                (_a = track.audioTrack) === null || _a === void 0 ? void 0 : _a.detach(el);
            }
        };
    }, [track]);
    useEffect(() => {
        const el = ref.current;
        if (el && typeof (participant === null || participant === void 0 ? void 0 : participant.audioVolume) !== 'undefined') {
            el.volume = participant.audioVolume;
        }
    }, [ref, participant === null || participant === void 0 ? void 0 : participant.audioVolume]);
    return (_jsx("div", { style: { display: 'none' }, children: _jsx("audio", { autoPlay: true, ref: ref }) }));
};
_react_refresh_temp_1 = AudioElm;
$RefreshReg$(_react_refresh_temp_1, "AudioElm");
_react_refresh_temp_3(AudioElm, "SVME8SsuyZhcraWXAMSnWEnZJfs=", false, () => [useAppSelector]);
export default _react_refresh_temp_2 = React.memo(AudioElm);
$RefreshReg$(_react_refresh_temp_2, "%default%");
